import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
// import Breadcrumb from "../components/Breadcrumb";
import ComingSoonLayerOne from "../components/ComingSoonLayerOne";


const ContactUsPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        {/* <Breadcrumb title="Change Password" tooltipContent="Add New User" linkTo="/users/add" /> */}
        
        {/* ViewProfileLayer */}
        <ComingSoonLayerOne />

      </MasterLayout>

    </>
  );
};

export default ContactUsPage; 
